import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DashboardWrapper } from "./Components";
import {
  ListRoomTypes,
  ListReservations,
  CreateRoomType,
  ListRates,
  CreateRate,
  EditRates,
  UpdateRoomType,
  ListServices,
  CreateService,
  UpdateService,
  CreateReservation,
  UpdateRate,
  Settings,
  CreateStaff,
  ListStaff,
  ImagesManager,
  HomeSliderManger,
  HomeGallerieManager,
  GallerieManager,
  // CreateTeam,
  UpdateStaff,
  ListTeam,
  ListMenus,
  CreateConferenceRoom,
  ListConferenceRooms,
  UpdateConferenceRoom,
  CreateConferenceReservation,
  Login,
  Dashboard,
  PricingCalendar,
  ListFloors,
  ListRoomItem,
  AddRoomItem
} from "./Pages";
import { Toaster } from "react-hot-toast";
import { useState } from "react";
import { isAuth } from "./Utils/auth";

import { NotificationProvider } from "./NotificationContext";


const App = () => {
  //this code is so bad you better find a better way to handle client auth token, tf who cares i ain't changing shit ...

  var setupTime = localStorage.getItem("setupTime");
  if (setupTime == null) {
    localStorage.setItem("setupTime", new Date().getTime());
  } else {
    if (new Date().getTime() - setupTime > 2 * 60 * 60 * 1000) {
      localStorage.removeItem("accesstokenhotelparkmall");
      localStorage.setItem("setupTime", new Date().getTime());
    }
  }

  const [auth] = useState(isAuth());
  //const [auth] = useState(false);

  if (!auth && window.location.pathname.toString() !== "/login")
    window.location = "/login";

  if (auth && window.location.pathname.toString() === "/login")
    window.location = "/";

  return (
    <NotificationProvider>
    <BrowserRouter>
      <Toaster position="bottom-center" />
      {auth ? (
        <DashboardWrapper>
          <Routes>
            <Route element={<Dashboard />} index />
            <Route path="/calendar" element={<PricingCalendar />} />
            <Route path="/content">
              <Route index element={<ImagesManager />} />
              <Route path="slider" element={<HomeSliderManger />} />
              <Route path="home_gallerie" element={<HomeGallerieManager />} />
              <Route path="gallerie" element={<GallerieManager />} />
            </Route>
            <Route path="/reservations">
              <Route index element={<ListReservations />} />
              <Route path="create" element={<CreateReservation />} />
              <Route
                path="conference"
                element={<CreateConferenceReservation />}
              />
            </Route>
            <Route path="/rooms">
              <Route index element={<ListRoomTypes />} />
              <Route path="create" element={<CreateRoomType />} />
              <Route path="update/:roomId" element={<UpdateRoomType />} />
            </Route>
            <Route path="/rates">
              <Route index element={<ListRates />} />
              <Route path="create" element={<CreateRate />} />
              <Route path="edit/:rateId" element={<EditRates />} />
              <Route path="update/:rateId" element={<UpdateRate />} />
            </Route>
            <Route path="/services">
              <Route index element={<ListServices />} />
              <Route path="create" element={<CreateService />} />
              <Route path="update/:serviceId" element={<UpdateService />} />
            </Route>

            {/* MALEK */}
            <Route path="/roomItem">
              <Route index element={<ListRoomItem/>}/>
              <Route path="create" element={<AddRoomItem />} />
            </Route>
            <Route path="/floors">
              <Route index element={<ListFloors/>}/>
            </Route>
            
            {/* <Route path="/teams">
              <Route index element={<ListTeam />} />
              <Route path="create" element={<CreateTeam />} />
            </Route>
            <Route path="/staff">
              <Route index element={<ListStaff />} />
              <Route path="create" element={<CreateStaff />} />
              <Route path="update/:staffId" element={<UpdateStaff />} />
            </Route>
            <Route path="/conferences">
              <Route index element={<ListConferenceRooms />} />
              <Route path="create" element={<CreateConferenceRoom />} />
              <Route path="update/:confId" element={<UpdateConferenceRoom />} />
            </Route>
            <Route path="/menus">
              <Route index element={<ListMenus />} />
            </Route> */}
            <Route path="/settings" element={<Settings />} />
            {/* <Route path="/favorite" element={<></>} />
            <Route path="/profile" element={<></>} /> */}
          </Routes>
        </DashboardWrapper>
      ) : (
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      )}
    </BrowserRouter>
    </NotificationProvider>
  );
};

export default App;
